import React from "react";
import { Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import MenuBookOutlinedIcon from "@material-ui/icons/MenuBookOutlined";

import Title from "../components/title";
import Blog from "../components/blog";
import { getTranslate } from "../localization";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: "100vh",
    padding: "52px 44px 90px",
    direction: theme.direction,
    textAlign: theme.direction === "rtl" ? "right" : "left",
    [theme.breakpoints.down("sm")]: { padding: "34px 22px 64px" },
    [theme.breakpoints.down("xs")]: { padding: "28px 16px 56px" },
  },
  inner: {
    width: "min(100%, 1220px)",
    margin: "0 auto",
  },
  introCard: {
    position: "relative",
    padding: 24,
    marginBottom: 34,
    borderRadius: 20,
    overflow: "hidden",
    background: "linear-gradient(145deg,var(--surface-strong),var(--surface))",
    border: "1px solid var(--border)",
    boxShadow: "var(--shadow-sm)",
    [theme.breakpoints.down("xs")]: { padding: 18 },
  },
  introTop: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 9,
    direction: theme.direction,
  },
  introIcon: { color: "var(--accent)", fontSize: 25 },
  introTitle: { color: "var(--text-primary)", fontWeight: 850, fontSize: 17 },
  lead: {
    maxWidth: 900,
    color: "var(--text-secondary)",
    fontSize: 13,
    lineHeight: 1.95,
  },
  disclosure: {
    marginTop: 10,
    color: "var(--text-muted)",
    fontSize: 10.5,
    lineHeight: 1.75,
  },
  topics: {
    display: "flex",
    flexWrap: "wrap",
    gap: 7,
    marginTop: 17,
  },
  topic: {
    height: 28,
    color: "var(--text-soft)",
    fontSize: 9.5,
    background: "var(--accent-soft)",
    border: "1px solid var(--border-accent)",
  },
}));

export default function BlogScreen() {
  const classes = useStyles();
  const translate = getTranslate();

  return (
    <div className={`${classes.root} modern-page`}>
      <div className={classes.inner}>
        <Title title={translate.writingPageTitle} eyebrow={translate.writingEyebrow} />

        <section className={classes.introCard}>
          <div className={classes.introTop}>
            <MenuBookOutlinedIcon className={classes.introIcon} />
            <Typography component="h2" className={classes.introTitle}>{translate.writingIntroTitle}</Typography>
          </div>
          <div className={classes.lead}>{translate.writingLead}</div>
          <div className={classes.disclosure}>{translate.writingDisclosure}</div>
          <div className={classes.topics}>
            {translate.writingTopics.map((topic) => (
              <Chip key={topic} label={topic} variant="outlined" className={classes.topic} />
            ))}
          </div>
        </section>

        <Grid container spacing={3}>
          {translate.blogsList.map((item) => (
            <Grid item xs={12} md={6} key={item.id}>
              <Blog item={item} readLabel={translate.readArticle} />
            </Grid>
          ))}
        </Grid>
      </div>
    </div>
  );
}
